import React from 'react';
import styles from './ProgressSteps.module.css';
import type { ForemanProgress } from '../../types/foreman';

interface ProgressStepsProps {
  steps: ForemanProgress[];
}

const ProgressSteps: React.FC<ProgressStepsProps> = ({ steps }) => {
  return (
    <div className={styles.wrapper}>
      {steps.map((step, idx) => (
        <div
          key={idx}
          className={`${styles.step} ${step.done ? styles.done : styles.pending}`}
        >
          <div className={styles.indicator}>
            <div className={styles.dot}>
              {step.done ? '\u2713' : '\u25CB'}
            </div>
            {idx < steps.length - 1 && <div className={styles.connector} />}
          </div>
          <span className={styles.label}>{step.label}</span>
        </div>
      ))}
    </div>
  );
};

export default ProgressSteps;
